import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowRight, Mail, Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function FinalCTA() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email || !email.includes("@")) {
            toast.error("Merci d'entrer une adresse e-mail valide.");
            return;
        }
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setEmail("");
            toast.success("Inscription confirmée !", {
                description: "Vous serez prévenu·e dès qu'un nouvel outil SaaS rejoindra la suite Web Me Up.",
            });
        }, 900);
    };

    return (
        <section id="cta" className="relative py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <div className="relative overflow-hidden rounded-3xl border border-border bg-gradient-card p-1">
                    {/* Aurora glow */}
                    <div className="pointer-events-none absolute inset-0">
                        <div className="absolute -left-20 top-1/2 h-80 w-80 -translate-y-1/2 rounded-full bg-primary/30 blur-3xl animate-aurora-shift" />
                        <div className="absolute -right-20 top-1/2 h-80 w-80 -translate-y-1/2 rounded-full bg-accent/25 blur-3xl animate-aurora-shift" />
                    </div>

                    <div className="relative rounded-[calc(1.5rem-4px)] bg-background/70 px-6 py-14 backdrop-blur sm:px-12 sm:py-20">
                        <div className="mx-auto max-w-3xl text-center">
                            <div className="inline-flex items-center gap-2 rounded-full border border-border bg-card/60 px-3 py-1 text-xs text-muted-foreground backdrop-blur">
                                <Sparkles className="h-3.5 w-3.5 text-primary" />
                                Prêt à équiper votre agence ?
                            </div>
                            <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-foreground sm:text-5xl lg:text-6xl">
                                Testez la suite.<br />
                                <span className="text-gradient">Gardez ce qui rapporte.</span>
                            </h2>
                            <p className="mx-auto mt-5 max-w-xl text-base text-muted-foreground sm:text-lg">
                                Activez un SaaS aujourd'hui, mesurez l'impact en 30 jours. Ou inscrivez-vous pour être prévenu·e dès qu'un nouvel outil interne devient public.
                            </p>

                            <form onSubmit={handleSubmit} className="mx-auto mt-9 flex max-w-md flex-col gap-2 sm:flex-row">
                                <div className="relative flex-1">
                                    <Mail className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                                    <Input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="vous@votre-agence.com"
                                        className="h-12 rounded-xl border-border bg-card/60 pl-11 text-foreground placeholder:text-muted-foreground focus-visible:ring-primary"
                                    />
                                </div>
                                <Button
                                    type="submit"
                                    disabled={loading}
                                    size="lg"
                                    className="h-12 rounded-xl bg-gradient-primary px-6 font-semibold text-primary-foreground shadow-glow hover:opacity-95"
                                >
                                    {loading ? "Envoi…" : (
                                        <span className="inline-flex items-center gap-1.5">
                                            Me prévenir <ArrowRight className="h-4 w-4" />
                                        </span>
                                    )}
                                </Button>
                            </form>

                            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-muted-foreground">
                                <span>Sans spam.</span>
                                <span className="h-1 w-1 rounded-full bg-border" />
                                <span>Désinscription en 1 clic.</span>
                                <span className="h-1 w-1 rounded-full bg-border" />
                                <span>~1 e-mail par lancement.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
